import { Routes, Route } from "react-router-dom";
import Home from "../Pages/Home";
import Publications from "../Pages/Publications";
import GroupMembers from "../Pages/GroupMembers";
import MaterialsLibrary from "../Pages/MaterialsLibrary";
import LabFacilities from "../Pages/LabFacilities";
import UnderConstruction from "../Pages/UnderConstruction";
import NotFound from "../Pages/NotFound";
import Gallery from "../Pages/Gallery";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/publications" element={<Publications />} />
      <Route path="/group-members" element={<GroupMembers />} />
      <Route path="/materials-library" element={<MaterialsLibrary />} />
      <Route path="/lab-facilities" element={<LabFacilities />} />
      <Route path="/bio" element={<UnderConstruction />} />
      <Route path="/electrochemistry" element={<UnderConstruction />} />
      <Route path="/gallery" element={<Gallery />} />
      {/* 404 catch-all route */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;